import blade from "../lottie/blade.json";
import flame from "../lottie/flame.json";
import favouritesLottie from "../lottie/heart_animation.json";
import recipeMealPlanLoaderlottie from "../lottie/recipeMealPlanLoader.json"
import recipeMealPlanSuccess from "../lottie/recipeMealPlanSuccessTick.json"

export const RecipeMealPlanLoad = recipeMealPlanLoaderlottie;
export const RecipeMealPlanSuccess = recipeMealPlanSuccess;
export const FavouritesLottie = favouritesLottie;
export const FlameLottie = flame;
export const BladeLottie = blade;